import { render, staticRenderFns } from "./is-ptf.vue?vue&type=template&id=7743f04f&scoped=true"
import script from "./is-ptf.vue?vue&type=script&lang=js"
export * from "./is-ptf.vue?vue&type=script&lang=js"
import style0 from "./is-ptf.vue?vue&type=style&index=0&id=7743f04f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7743f04f",
  null
  
)

export default component.exports